<!-- <div [class]="'kanaal-cell'" (click)="this.click.emit()"> -->
    @if (this.cell().length > 0) {
    <!-- <div class="d-assignement-wrapper" [class.hovered]="this.isSelected()"> -->
            @for(assign of this.cell(); track $index) {
                @if ($index == 0) {
                    <div class="kanaal-label">
                        <span [class.vrij]="this.cell().length == 0 && !this.isSelected()" 
                        [class.one-assign]="this.cell().length == 1 && !this.isSelected()"
                        [class.multi-assign]="this.cell().length > 1 && !this.isSelected()" [class.kanaal-selected]="this.isSelected()">{{this.label()}}</span></div>
                } @else {
                    <span class="kanaal-label"></span>
                }
                <div class="afd-label" [class.vrij]="this.cell().length == 0 && !this.isSelected()" 
                [class.one-assign]="this.cell().length == 1 && !this.isSelected()"
                [class.multi-assign]="this.cell().length > 1 && !this.isSelected()" [class.kanaal-selected]="this.isSelected()">{{assign.assignement.afdeling}}</div>
                <div class="desc-label" [class.vrij]="this.cell().length == 0 && !this.isSelected()" 
                [class.one-assign]="this.cell().length == 1 && !this.isSelected()"
                [class.multi-assign]="this.cell().length > 1 && !this.isSelected()" [class.kanaal-selected]="this.isSelected()">{{assign.assignement.omschrijving}}</div>
            }
    <!-- </div> -->
    } @else {
        <div class="kanaal-label">
            <span [class.vrij]="this.cell().length == 0 && !this.isSelected()" 
            [class.one-assign]="this.cell().length == 1 && !this.isSelected()"
            [class.multi-assign]="this.cell().length > 1 && !this.isSelected()" [class.kanaal-selected]="this.isSelected()">{{this.label()}}</span></div>
        <span [class.vrij]="this.cell().length == 0 && !this.isSelected()" 
        [class.one-assign]="this.cell().length == 1 && !this.isSelected()"
        [class.multi-assign]="this.cell().length > 1 && !this.isSelected()" [class.kanaal-selected]="this.isSelected()">-</span>
        <span class="desc-label" [class.vrij]="this.cell().length == 0 && !this.isSelected()" 
        [class.one-assign]="this.cell().length == 1 && !this.isSelected()"
        [class.multi-assign]="this.cell().length > 1 && !this.isSelected()" [class.kanaal-selected]="this.isSelected()">-</span>
    }
    <div class="spacer"></div>
<!-- </div> -->
